import ajax from "../../lib/ajax";
const account = {
  namespaced: true,
  state: {
    emailConfirmed: false,
    confirmedEmailAddress: null
  },
  actions: {
    async isTenantAvailable(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/IsTenantAvailable", payload.data);
      return rep.data.result;
    },
    async register(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/Register", payload.data);
      return rep.data.result;
    },
    async uploadAvatar(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/UploadAvatar", payload);
      return rep.data.result;
    },
    async updateProfile(state: any, payload: any) {
      let rep = await ajax.put("/api/services/app/Account/UpdateProfile", payload);
      return rep.data.result;
    },
    async createBillingAccount(state: any, payload: any) {
      return ajax.post("/api/services/app/Account/CreateBillingAccount", payload);
    },
    async forgotPassword(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/ForgotPassword", payload);
      return rep.data.result;
    },
    async resetPassword(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/ResetPassword", payload);
      return rep.data.result;
    },
    async sendEmailAddressConfirmation(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/SendEmailAddressConfirmation", payload);
      return rep.data.result;
    },
    async confirmEmailAddress(state: any, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/ConfirmEmailAddress", payload);
      return rep.data.result;
    },
    setEmailConfirmed(context: any, payload: any) {
      context.state.emailConfirmed = true;
      context.state.confirmedEmailAddress = payload.emailAddress;
    }
  }
};
export default account;
